import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailX, CheckCircle2, AlertTriangle } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const [state, setState] = useState("working"); // working | done | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token") || "";
    if (!token) {
      setState("error");
      setMessage("Missing unsubscribe token — use the link from your email.");
      return;
    }
    api.post("/marketing/unsubscribe", { token })
      .then((r) => { setState("done"); setMessage(r.data.message); })
      .catch((err) => { setState("error"); setMessage(formatApiErrorDetail(err.response?.data?.detail)); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="unsubscribe-page" className="min-h-screen flex items-center justify-center bg-[#050505] p-4 relative">
      <div className="absolute inset-0 grid-texture opacity-50" />
      <div className="relative w-full max-w-sm border border-white/10 bg-black/60 backdrop-blur-md p-8 flex flex-col items-center gap-4 text-center">
        <MailX className="w-8 h-8 text-nc-orange" />
        <p className="font-mono text-[10px] tracking-[0.3em] text-zinc-400 uppercase">Specpixel // Email Preferences</p>
        {state === "working" && <p data-testid="unsubscribe-working" className="font-mono text-xs text-zinc-500 animate-pulse">Updating your preferences…</p>}
        {state === "done" && (
          <>
            <CheckCircle2 className="w-6 h-6 text-nc-green" />
            <p data-testid="unsubscribe-done" className="font-mono text-xs text-zinc-300 leading-relaxed">{message}</p>
          </>
        )}
        {state === "error" && (
          <>
            <AlertTriangle className="w-6 h-6 text-red-400" />
            <p data-testid="unsubscribe-error" className="font-mono text-xs text-red-400 leading-relaxed">{message}</p>
          </>
        )}
        <Link to="/" data-testid="unsubscribe-home-link" className="font-mono text-[10px] tracking-[0.25em] text-nc-blue hover:text-zinc-100 uppercase transition-colors mt-2">
          Back to specpixel.com
        </Link>
      </div>
    </div>
  );
}
